export type Lang = 'jp' | 'en';

export const requiredText: Record<Lang, string> = {
  jp: '必須',
  en: 'required',
};
